<template>
  <v-tabs fixed-tabs :v-once="query">
    <v-tab ripple> Claim Info </v-tab>
    <v-tab ripple :disabled="showFlowBtn()"> Status History </v-tab>
    <v-tab-item>
      <ClaimQuickInfo :reserveInfo="showFlowBtn()"></ClaimQuickInfo>
    </v-tab-item>
    <v-tab-item>
      <status-history @statusChange="doEditStatusChange"></status-history>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import ClaimQuickInfo from './ClaimQuickInfo'
import StatusHistory from '../StatusHistory'
import routeMixin from '@/mixins/route'

export default {
  methods: {
    showFlowBtn() {
      // We only want to show at specific module page
      return this.isMatchRoute('claimRegister')
    },
    doEditStatusChange() {
      // console.log(true)
      this.$emit('statusChange')
    }
  },
  components: {
    ClaimQuickInfo,
    StatusHistory
  },
  mixins: [routeMixin],
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
// Will inherit the css from LifeCycle (as this is the child component)
</style>
